import moment from 'moment';

export const formatISODate = (isoDateString: string) => {
  return moment(offsettedDate(isoDateString)).format('dddd, MMMM Do YYYY');
};

export const formatISODateTime = (isoDateString: string) => {
  return moment(offsettedDate(isoDateString)).format('MMM, DD, YYYY, h:mm A');
};

export const formatISODateToShort = (isoDateString: string) => {
  return moment(offsettedDate(isoDateString)).format('MMM Do YYYY');
};

export const offsettedDate = (isoDateString: string) => {
  const date = new Date(isoDateString);
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + userTimezoneOffset);
};

export const isStagingEnv = () => {
  return process.env.GATSBY_ENV_NAME === 'staging';
};

export const isValidEmail = (email: string) => {
  return /^\S+@\S+$/.test(email);
};
